import React from 'react';
import { VariantConsumer } from '../../FoodMenu.context';
import { navigationVariantComponentMap } from '../variants/navigation';
export default function MenuNavigation(props) {
  return /*#__PURE__*/React.createElement(VariantConsumer, null, function (_ref) {
    var navDisplay = _ref.navDisplay;
    var NavigationVariant = navigationVariantComponentMap[navDisplay];
    return /*#__PURE__*/React.createElement(NavigationVariant, props);
  });
}